<template>
  <div v-loading="fetchingCommercialAlternatives || fetchingDispensableAlternatives" class="medication-search-input">
    <app-medication-search
      id="medication-search"
      ref="medication-search"
      :value="search"
      :loading="searchingMedication"
      :medications="medicationResults"
      placeholder="Buscar Medicamento"
      @search="handleMedicationSearch"
      @input="handleSelectMedication" />

    <div v-if="blocked" class="alert alert-danger">
      No se puede prescribir el medicamento seleccionado ya que la receta posee otros medicamentos. Solo puede prescribirse por si solo.
    </div>

    <el-collapse v-else v-model="activeCollapseItems" @change="handleChangeMedicationDetails">
      <el-collapse-item name="medication-details">
        <template v-slot:title>
          Detalle medicamento<span class="text-red">&nbsp;*</span>
        </template>
        <app-medication-search
          ref="clinic-medication-search"
          :required="true"
          :value="value.clinicalMedication"
          :loading="searchingClinicalMedication"
          :medications="clinicalMedicationAlternatives"
          placeholder="Buscar Medicamento Clínico"
          @input="handleSelectClinicalMedication" />
        <app-medication-search
          ref="comercial-medication-search"
          :value="value.commercialMedication"
          :loading="fetchingCommercialAlternatives"
          :disable="fetchingCommercialAlternatives"
          :medications="commercialAlternatives"
          placeholder="Seleccionar medicamento comercial"
          @input="handleSelectCommercialMedication" />
          <!--
        <app-medication-search
          v-if="recommendedDispensableMedication"
          ref="dispensable-medication-search"
          :value="value.dispensableMedication"
          :loading="fetchingDispensableAlternatives"
          :disable="fetchingDispensableAlternatives"
          :medications="dispensableAlternatives"
          placeholder="Seleccionar medicamento comercial con envase"
          @input="handleSelectedDispensableMedication" />

          -->
      </el-collapse-item>
    </el-collapse>
  </div>
</template>

<script>
import AppMedicationSearch from '@/components/AppMedicationSearch';
import _debounce from 'lodash/debounce';
import _cloneDeep from 'lodash/cloneDeep';
import _pick from 'lodash/pick';
import _get from 'lodash/get';

export default {
  name: 'MedicationReferenceInput',
  components: {
    AppMedicationSearch
  },
  props: {
    value: {
      type: Object,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    inputId: {
      type: String,
      default: ''
    },
    recommendedCommercialMedication: {
      type: String,
      default: null
    },
    blocked: {
      type: Boolean,
      default: false
    },
    recommendedDispensableMedication: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      medicationResults: [],
      searchingMedication: false,
      searchingClinicalMedication: false,
      fetchingCommercialAlternatives: false,
      fetchingClinicalMedication: false,
      fetchingDispensableAlternatives: false,
      commercialAlternatives: [],
      clinicalMedicationAlternatives: [],
      dispensableAlternatives: [],
      resetMedications: false,
      search: { display: '' },
      activeSearchQuery: '',
      activeCollapseItems: [],
      refsets: []
    };
  },
  created() {
    if (Object.keys(this.value.clinicalMedication).length) {
      this.fetchCommercialAlternatives(this.value.clinicalMedication);
      this.showMedicationDetails();
    }
    if (Object.keys(this.value.commercialMedication).length) {
      this.fetchDispensableCommercialAlternatives(this.value.commercialMedication);
    }
  },
  methods: {
    showMedicationDetails() {
      this.handleChangeMedicationDetails(['medication-details']);
    },
    handleChangeMedicationDetails(newState) {
      this.activeCollapseItems = newState;
    },
    async focusSelectReference(selectReference) {
      return this.$nextTick(() => {
        if (this.blocked) {
          return;
        }
        this.$refs[selectReference].$refs['el-select'].focus();
      });
    },
    async handleSelectBasicMedication(basicMedicationReference) {
      this.$emit('input', {
        clinicalMedication: {},
        commercialMedication: {},
        dispensableMedication: {},
        reference: basicMedicationReference.reference
      });
      await this.$nextTick();
      this.clinicalMedicationAlternatives = [];
      this.commercialAlternatives = [];
      this.dispensableAlternatives = [];
      if (!basicMedicationReference) return;
      await this.fetchClinicalMedication(basicMedicationReference, true);
      return this.focusSelectReference('clinic-medication-search');
    },
    async handleSelectClinicalMedication(clinicalMedication, skipFocus = false) {
      await this.fetchRefs(clinicalMedication);

      this.$emit('input', {
        clinicalMedication: _pick(_cloneDeep(clinicalMedication), ['display', 'reference']),
        commercialMedication: _pick(_cloneDeep(this.value.commercialMedication), ['display', 'reference']),
        dispensableMedication: _pick(_cloneDeep(this.value.dispensableMedication), ['display', 'reference']),
        refsets: _cloneDeep(this.refsets)
      });
      this.commercialAlternatives = [];
      this.dispensableAlternatives = [];
      await this.$nextTick();

      document.getElementById('medication-dose-value').focus();

      await this.fetchCommercialAlternatives(clinicalMedication);
      if (skipFocus) return;

      return null; // this.focusSelectReference('comercial-medication-search');
    },
    async handleSelectCommercialMedication(commercialMedicationReference, skipFocus = false) {
      this.$emit('input', {
        clinicalMedication: _pick(_cloneDeep(this.value.clinicalMedication), ['display', 'reference']),
        commercialMedication: _pick(_cloneDeep(commercialMedicationReference), ['display', 'reference']),
        dispensableMedication: this.resetMedications ? {} : _pick(_cloneDeep(this.value.dispensableMedication), ['display', 'reference'])
      });
      this.dispensableAlternatives = [];
      await this.$nextTick();
      this.resetMedications = true;
      this.fetchDispensableCommercialAlternatives(commercialMedicationReference);
      if (skipFocus) return;
      return this.focusSelectReference('dispensable-medication-search');
    },
    handleSelectedDispensableMedication(dispensableMedication) {
      this.dispensableMedication = _cloneDeep(dispensableMedication);
      this.$emit('input', {
        clinicalMedication: _pick(_cloneDeep(this.value.clinicalMedication), ['display', 'reference']),
        commercialMedication: _pick(_cloneDeep(this.value.commercialMedication), ['display', 'reference']),
        dispensableMedication: _pick(dispensableMedication, ['display', 'reference']),
        reference: dispensableMedication.medicationReference
      });
    },
    async handleSelectMedication(medication) {
      this.$emit('input', {
        clinicalMedication: {},
        commercialMedication: {},
        dispensableMedication: {}
      });
      if (medication) this.showMedicationDetails();
      if (!medication || medication.original.nombreCategoria.includes('Básico')) {
        await this.handleSelectBasicMedication(medication);
      } else {
        if (medication.original.nombreCategoria.includes('Clínico')) {
          await this.handleSelectClinicalMedication(medication);
        }
        if (medication.original.nombreCategoria.includes('Comercial')) {
          await this.fetchClinicalMedication(medication);
          await this.handleSelectCommercialMedication(medication);
          return this.focusSelectReference('dispensable-medication-search');
        }
      }
    },
    async fetchClinicalMedication(medication) {
      this.fetchingClinicalMedication = true;
      return this.$store.dispatch('fetchClinicalMedication', medication)
        .then(response => {
          this.clinicalMedicationAlternatives = response.data;
          if (_get(response, 'data', []).length === 1) {
            this.handleSelectClinicalMedication(response.data[0], true);
          }
        })
        .finally(() => {
          this.fetchingClinicalMedication = false;
        });
    },
    async fetchCommercialAlternatives(clinicalMedication) {
      this.fetchingCommercialAlternatives = true;
      return this.$store.dispatch('fetchCommercialAlternatives', clinicalMedication)
        .then(response => {
          this.commercialAlternatives = response.data;
          let matchRecommended = null;
          if (this.recommendedCommercialMedication) {
            matchRecommended = this.commercialAlternatives.find(m => m.reference === this.recommendedCommercialMedication);
            if (matchRecommended) {
              matchRecommended.recommended = true;
              this.handleSelectCommercialMedication(matchRecommended, true);
            }
          }
          if (!matchRecommended && this.commercialAlternatives.length === 1) {
            this.handleSelectCommercialMedication(this.commercialAlternatives[0], true);
          }
        })
        .finally(() => {
          this.fetchingCommercialAlternatives = false;
        });
    },
    async fetchRefs(clinicalMedication, callback) {
      return this.$store.dispatch('fetchRefsMedication', clinicalMedication)
        .then(response => {
          this.refsets = response.data;
        })
        .finally(() => {

        });
    },
    fetchDispensableCommercialAlternatives(commercialMedicationReference) {
      this.fetchingDispensableAlternatives = true;
      this.$store.dispatch('fetchDispensableCommercialAlternatives', commercialMedicationReference)
        .then(response => {
          this.dispensableAlternatives = response.data;
          if (this.dispensableAlternatives.length === 1) {
            this.handleSelectedDispensableMedication(this.dispensableAlternatives[0]);
          }
        })
        .finally(() => {
          this.fetchingDispensableAlternatives = false;
        });
    },
    handleMedicationSearch: _debounce(function(query) {
      this.activeSearchQuery = query;
      this.searchingMedication = true;
      this.medicationResults = [];
      this.search.display = '';

      if (query.length < 3) {
        return;
      }

      this.$store.dispatch('searchMultipleMedication', this.activeSearchQuery)
        .then(({ requestSearch, response }) => {
          if (requestSearch === this.activeSearchQuery) {
            this.medicationResults = response;
          }
        })
        .catch(e => {
          console.log('e', e);
        })
        .finally(() => {
          this.searchingMedication = false;
        });
    }),
    handleClinicalMedicationSearch: _debounce(function(search) {
      this.searchingClinicalMedication = true;
      this.clinicalMedicationAlternatives = [];
      this.$store.dispatch('searchMedication', search)
        .then(({ requestSearch, response }) => {
          if (requestSearch === search) {
            this.clinicalMedicationAlternatives = response.data;
          }
        })
        .catch(e => {
          console.log('e', e);
        })
        .finally(() => {
          this.searchingClinicalMedication = false;
        });
    }, 400)
  }
};
</script>

<style lang="scss">
.medication-search-input {
  display: flex;
  flex-direction: column;

  input {
    margin-bottom: $--spacing-2;
  }
}
/*Fixes double tap on iOS*/
.el-scrollbar__bar {
    opacity: 1!important;
}
</style>
